import styles from './user-info-data.module.css';
import { Skeleton } from 'primereact/skeleton';
import { useAuthContext } from '../../../../context/AuthContext';

export const UserInfoData = () => {
  const { userCaption, userRole } = useAuthContext();
  const getUserCaption = (userCaption: string) => {
    switch (userCaption) {
      case 'adm':
        return 'Администратор';
      case 'adm_mc':
        return 'Администратор УК';
      case 'usr':
        return 'Пользователь';
      default:
        return '';
    }
  };
  return (
    <div className={styles.user_info_data__container}>
      {userCaption ? (
        <div
          className={styles.title}
          data-at-wc-header-caption
          title={userCaption}
        >
          {userCaption}
        </div>
      ) : (
        <Skeleton width="7rem"></Skeleton>
      )}
      {userRole ? (
        <div className={styles.role} data-at-wc-header-role>
          {getUserCaption(userRole)}
        </div>
      ) : (
        <Skeleton width="7rem"></Skeleton>
      )}
    </div>
  );
};
